export default __webpack_public_path__ + "static/media/ok.4435a170.svg";